import React from "react";
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";

// segments: [{ label, count, color }] — colors are passed in by the caller
// (Dashboard.jsx / NewDashboard1.jsx) using the SAME status-color mapping
// already used for tiles/calendar events, so a segment's color always
// matches its status everywhere else on the page.
const StatusDonutChart = ({ segments = [], total = 0 }) => {
  const data = segments.filter((s) => s.count > 0);

  if (!data.length) {
    return (
      <div style={{ padding: "32px", textAlign: "center", color: "#9CA3AF", fontSize: "14px" }}>
        No data available
      </div>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      <ResponsiveContainer width="100%" height={240}>
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey="label"
            innerRadius={65}
            outerRadius={95}
            paddingAngle={2}
            stroke="#fff"
            strokeWidth={2}
          >
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.color} />
            ))}
          </Pie>
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="middle"
            iconType="circle"
            iconSize={8}
            formatter={(value, entry) => {
              const item = data.find((d) => d.label === value);
              if (!item) return null;
              const pct = total ? ((item.count / total) * 100).toFixed(1) : 0;
              return (
                <span style={{ fontSize: "12px", color: "#374151" }}>
                  {value} <strong>{item.count}</strong>
                </span>
              );
            }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "38%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          pointerEvents: "none",
        }}
      >
        <div style={{ fontSize: "24px", fontWeight: 700, color: "#111827" }}>{total}</div>
        <div style={{ fontSize: "12px", color: "#6B7280" }}>Total</div>
      </div>
    </div>
  );
};

export default StatusDonutChart;
